export const blockIconsNavigationSouth = (
	<span className='material-symbols-outlined'>south</span>
);
